import { SpecialAction } from '../SpecialAction';

export class SpecialTimerTick extends SpecialAction {
    id = '*timer-tick';

    constructor(_: {}) {
        super();
    }
}
